import { usePage } from '@inertiajs/react';
import classNames from 'classnames';
import { User } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { useLocale } from '../../Shared/locale';
import { Campaign, Event, Project } from '../../Shared/types';
import { Card } from '../../Shared/UI/Card';
import { Icon } from '../../Shared/UI/Icon';
import { useRouter } from '../router';
import ProjectIcon from '../Settings/Projects/ProjectIcon';
import { PageProps } from '../types';
import { CampaignLogo } from './CampaignLogo';

export default function CampaignCard({
  campaign,
}: {
  campaign: Campaign & {
    project: Project;
    event: Event | null;
    team: Campaign | null;
  };
}) {
  const { t } = useTranslation();
  const { formatCurrency, formatDate } = useLocale();
  const { charity } = usePage<PageProps>().props;
  const { routes } = useRouter();

  const muted = !campaign.enabled && 'opacity-50';

  return (
    <Card
      spacing="xs"
      link={{
        href: routes.campaign_page(campaign.id),
        ariaLabel: campaign.title,
      }}
    >
      <div className="grid grid-cols-[60px_15fr_4fr_2fr] gap-4 items-center">
        <div className={classNames(muted)}>
          <CampaignLogo size="lg" campaign={campaign} charity={charity} />
        </div>
        <div className={classNames(muted, 'min-w-0 leading-snug')}>
          <h4 className="whitespace-nowrap overflow-hidden text-ellipsis">
            {campaign.title}
          </h4>
          <div className="whitespace-nowrap overflow-hidden text-ellipsis text-sm pr-4">
            <Icon className="mr-1">
              <User />
            </Icon>
            <span className="mr-3">
              {campaign.campaigner}
            </span>
            <ProjectIcon project={campaign.project} className="mr-1" />
            {campaign.project.title}
          </div>
        </div>
        <div className={classNames(muted, 'text-sm')}>
          <span className="font-medium">
            {formatCurrency(campaign.funds_raised)}
          </span>
          <div className="text-slate-400">
            {formatDate(campaign.created_at)}
          </div>
        </div>
        <div className={classNames('text-right text-sm font-medium', campaign.enabled ? 'text-emerald-600' : 'text-slate-500')}>
          {campaign.enabled ? t('backend:live') : t('backend:offline')}
        </div>
      </div>
    </Card>
  );
}
